module.exports = __webpack_public_path__ + "static/img/guestaps.cde6c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guestaps.png
// module id = rhe+
// module chunks = 0